import { SpeedOption } from "../models/itinerary-options.model";

export const NORMAL_SPEED:SpeedOption = {
    id: 'normal',
    label: 'routeForm.normal',
    speed: 1.4
}

export const SLOW_SPEED:SpeedOption = {
    id: 'slow',
    label: 'routeForm.slow',
    speed: 1.2
}


export const WALK_SPEED_OPTIONS = [NORMAL_SPEED, SLOW_SPEED];
